import { Outlet } from "react-router-dom";
import MobileHeader from "./MobileHeader";
import DesktopHeader from "./DesktopHeader";
import Sidebar from "./Sidebar";
import useIsMobile from "../../hooks/useIsMobile"; // Import the hook
import './Layout.css';

const Layout = () => {
    const isMobile = useIsMobile(); // Use the hook

    return (
        <>  
            {isMobile ? <MobileHeader /> : <DesktopHeader />}
            <div className="layout-grid">
                <Sidebar />
                <div className="content-area">
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default Layout;
